import React from 'react';

import { SmallSubtitle } from '../../../foundations/typefaces/SmallSubtitle';
import { Size, Variant } from './types';
import { TextLabelContainer } from './TextLabel.styled';

interface TextLabelProps {
  /**
   * text to display in the TextLabel
   */
  text: string;
  /**
   * Changes the size. It can be one of the following options:
   * `Button.Size.SMALL`, `Button.Size.BIG`
   */
  size?: Size;
  /**
   * Variant on which the button's style depends. Can be:
   * `Button.Variant.LIGHT`, `Button.Variant.DARK`, `Button.Variant.TERTIARY`
   */
  variant?: Variant;
  /**
   * Property used for testing purposes
   */
  dataCy?: string;
}

const TextLabel = ({
  text,
  size = Size.SMALL,
  variant = Variant.DARK,
  dataCy,
}: TextLabelProps) => {
  return (
    <TextLabelContainer $size={size} $variant={variant} data-cy={dataCy}>
      <SmallSubtitle>{text}</SmallSubtitle>
    </TextLabelContainer>
  );
};

TextLabel.Size = Size;
TextLabel.Variant = Variant;

export default TextLabel;
